//import axios from "axios";
import APIs from "../components/APIInit";
import store from "@/store";
import jQuery from "jquery";
let $ = jQuery;
import firebase from "firebase";
import "firebase/auth";
import router from "../router";
import analytics from "@/components/Analytics";
import jwt_decode from "jwt-decode";
import common from "@/common";
import { bus } from "@/main";

var self;
var funcTime = [];

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Sessions",
  "/session_cal": "session_cal",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

export default {
  methods: {

    sendAccessTokenForUserVerification(accessToken, provider) {
      var postData = {
        token: accessToken,
        provider: provider,
      };
      $.ajax({
        url: APIs.GetSocialTokenAPI,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () { },
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),
        success: function (data) {
          if (data.status >= 0) {
            self.showGoogleOneTapOption = false;
            firebase
              .auth()
              .signInWithCustomToken(data.customToken)
              .then(function () {
                var checkGoogleTapToSignin = document.getElementById(
                  "credential_picker_container"
                );
                if (checkGoogleTapToSignin) {
                  document.getElementById(
                    "credential_picker_container"
                  ).style.display = "none";
                }
                store.commit("setLoginType", "GoogleLogin");
                self.getEventDetails(data);
              })
              .catch(function () {
                alert("Unable to login");
              });
          } else {
            $("#btnLogin").val("Log In");
            self.showSnackbar(
              self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );
            return false;
          }
        },
        error: function (xhr, status, error) {
          $("#btnLogin").val("Log In");
          document.getElementById("dvOtherMsg").value =
            "Error in authentication process,please try again later. Error:" +
            error;
          $("#Othermsg-modal").modal("show");
        },
      });
      //-----------------------------------------------------------------
    },
    getEventDetails(data) {
      var userData = data.data;
      var email = userData.Email;
      var userRoles = userData.UserRoles;
      var isClientAdmin = false;
      var isEventAdmin = false;
      var roles = [];
      if (userRoles != undefined) {
        userRoles.forEach(function (role) {
          if (role.RoleID == 2) {
            isClientAdmin = true;
          } else if (role.RoleID == 3) {
            isEventAdmin = true;
          }
          roles.push(role.RoleID);
        });
      }
      var channelPrefix = "OAUAT";
      this.createLoginCookieForVideo(userData.UserId, channelPrefix);
      store.commit("addUser", {
        id: userData.UserId,
        Email: email,
        name: userData.Name,
        fname: userData.FirstName,
        lname: userData.LastName,
        profilepic: userData.ProfilePictureURL,
        company: userData.Company,
        title: userData.Designation,
        phone: userData.Phone,
        roles: roles,
      });
      debugger;
      var result = data.userEvents.result;
      var events = [];
      var i;
      var j;
      for (i = 0; i < result.length; ++i) {
        for (j = 0; j < result[i].events.length; j++) {
          if (!isClientAdmin && !isEventAdmin) {
            if (result[i].events[j].IsPublished == true) {
              events.push(result[i].events[j]);
              //store.commit("setMappedEvent", result[i].events[j]);
            }
          } else {
            events.push(result[i].events[j]);
            //store.commit("setMappedEvent", result[i].events[j]);
          }
        }
      }
      if (self.visitorLogin || self.autoLogin) {
        events = events.filter(function (item) {
          return item.EventId == self.eventId;
        });
      }
      store.commit("setMappedEvent", events);
      store.commit("addEventCount", events.length);

      if (data.signInType && data.signInType == "Google") {
        self.googleButtonLoader = false;
      }

      if (events.length == 0) {
        document.getElementById("dvOtherMsg").innerText = self.$t(
          "login.eventnotpublished"
        );
        $("#Othermsg-modal").modal("show");
        $("#btnLogin").val(self.$t("login.title"));
        self.loginText = self.$t("login.title");
      } else if (events.length > 1) {
        $("#btnLogin").prop("disabled", true);
        if (self.EnableSelfService && self.hasEventAdminRole()) {
          if (self.$route.fullPath == "/#cevent") {
            router.push("/eventoverview/#cevent");
          } else {
            router.push({ name: "AdminOverview" });
          }
        } else {
          router.push({ name: "EventList" });
        }
        console.log(funcTime);
      } else {
        $("#btnLogin").prop("disabled", true);
        if (self.$store.state.staySignedIn) {
          self.$store.state.historyEvent = events[0];
        }
        self.goToEvent(events);
      }
    },
    goToEvent: async function (eventDoc) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var eventData = eventDoc[0];
      this.$store.state.locale =
        eventData.DefaultLanguage === undefined
          ? "English"
          : eventData.DefaultLanguage;
      store.commit("addAttendeeID", obj.user[0].UserId);
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });
      // this.$store.commit(
      //   "setClientEventBranding",
      //   eventData.isCustomEventBranding
      // );
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName +
          "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data.customClientFont != undefined) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        } else {
          store.commit("AddEventFont", {
            FontPath: "",
            FontFamily: "",
          });
        }
      } catch (e) {
        store.commit("AddEventFont", {
          FontPath: "",
          FontFamily: "",
        });
        console.log("Error in Branding Json Fetch--", e);
      }

      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          this.item = brandingData.data;
          var bannerDymension = "2048x88"; //"640x88"; // "2048x88";
          var EventBgDymension = "2732x2048";
          var logoDymension = "960x192";
          store.commit("addEventBranding", {
            eventBGImage: self.getCDNUrl(
              brandingData.data.eventBGImage[EventBgDymension]
            ),
            eventLogo: self.getCDNUrl(
              brandingData.data.eventLogo[logoDymension]
            ),
            topBar: brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["topBar"] : brandingData.data.headerColorsHexCode["topBar"],
            headerBar: brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["headerBar"] : brandingData.data.headerColorsHexCode["headerBar"],
            fontBar:  brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["fontBar"] : brandingData.data.headerColorsHexCode["fontBar"],
            sideNavigationAndIconColor:
              brandingData.data.headerColorsHexCode[
              "sideNavigationAndIconColor"
              ],
            banner: self.getCDNUrl(brandingData.data.banner[bannerDymension]),
            mobileBanner: self.getCDNUrl(
              brandingData.data.banner["banner750x103"]
            ),
            shareBanner: self.getCDNUrl(
              brandingData.data.banner["1200x628"]
                ? brandingData.data.banner["1200x628"]
                : ""
            ),
            themeName: brandingData.data["appColorHexCodeType"],
          });
          $("#btnLoadMenu").click();
          this.getMeetingSettings();
          this.getAdvExpoStatus();
          this.getDynamicFont();
          let landingURL = "Lobby";
          if (
            eventData.DefaultLandingURL &&
            landingURLOptions[eventData.DefaultLandingURL] &&
            landingURLOptions[eventData.DefaultLandingURL] != ""
          ) {
            landingURL = landingURLOptions[eventData.DefaultLandingURL];
            store.commit("setDefaultLandingPageInsideEvent", landingURL);
          }
          if (this.$store.state.eventDefaultSessionPage) {
            landingURL =
              landingURLOptions[this.$store.state.eventDefaultSessionPage];
          }

          if (landingURL === "ExhibitorsHall") {
            this.onExpoSelection();
            store.commit("setAdvExpo", true);
          }
          analytics.AddUserLogin(
            eventData.EventCollectionName,
            eventData.EventFullName,
            location.pathname,
            "click",
            "action",
            obj.loginType,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email,
            obj.ClientIP
          );
          if (this.$store.state.staySignedIn)
            this.$store.state.historyLandinURL = landingURL;
          this.postLeaderboardAction("EVAC");

          if (self.hasRedirectUrl() && self.eventId) {
            self.goToRedirectUrl();
          } else {
            router.push({
              name: landingURL,
              params: {
                sid: eventDoc.id,
                eCol: eventData.EventCollectionName,
                ename: eventData.EventFullName,
                estartdt: eventData.EventStartDate,
                eenddt: eventData.EventEndDate,
                tzone: eventData.TimeZone,
              },
            });
          }
        }
      } catch (e) {
        self.mainLoginButtonLoader = false;
        console.log("Error in Branding Json Fetch--", e);
      }
    },

    FirebaseLoginWithAuthCommon(email, password) {

      bus.$emit("toggleLoader", true);
      // console.log(`Start Execution time:`, new Date());
      // this.showSnackbar("hide");
      // this.mainLoginButtonLoader = true;

      let that = this;
      self = this;

      // this.enableRules = true;

      // if (!self.visitorLogin && !enableEmailOnlyLogin) {
      //   if (self.hostExistcnt <= 0) {
      //     document.getElementById("dvOtherMsg").innerText = self.$t(
      //       "login.loginusingcorrecturl"
      //     );
      //     $("#Othermsg-modal").modal("show");
      //     return false;
      //   }
      //   if (
      //     this.txtUsername.toLowerCase() === "" ||
      //     (!(self.EnableEmailOnlyLogin || self.EventLogin) &&
      //       this.txtPassword === "")
      //   ) {
      //     that.loginText = self.$t("login.title");
      //     self.showSnackbar(
      //       this.eventId
      //         ? self
      //             .$t("login.entervalidemailandpwd")
      //             .replace("password", "event access code")
      //         : self.$t("login.entervalidemailandpwd"),
      //       "error",
      //       "top"
      //     );
      //     that.mainLoginButtonLoader = false;
      //     self.reLoginMessageFlg = true;
      //     if (self.allowreCAPTCHA) self.resetCaptcha();
      //     self.txtPassword = "";
      //     return false;
      //   }
      // }

      var apiUrl = APIs.FirebaseAuthApi;
      var postData = {
        emailId: email.toLowerCase(),
        password: password,
      };
      // if (!self.visitorLogin) {
      //   if (self.EnableEmailOnlyLogin || self.EventLogin) {
      //     postData = {
      //       emailId: self.txtUsername.toLowerCase(),
      //     };
      //   } else if (self.eventId) {
      //     postData = {
      //       emailId: self.txtUsername.toLowerCase(),
      //       accessCode: self.txtPassword,
      //       eventId: self.eventId,
      //       clientId: self.clientId,
      //     };
      //   }
      //   if (eventId && enableEmailOnlyLogin && email) {
      //     postData = {
      //       emailId: email,
      //       //eventId: self.eventId,
      //       //clientId: self.clientId,
      //     };
      //   }
      // } else {
      //   postData = {
      //     emailId: "visitor@e2m.live",
      //     //eventId: self.eventId,
      //     //clientId: self.clientId,
      //   };
      // }
      $.ajax({
        url: apiUrl,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () { },
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),
        success: function (data1) {
          console.log(`Api Success Execution time:`, new Date());
          console.log(`data:`, data1);
          console.log(`data:`, data1);
          console.log("data from api>>>>>>",data1);


          if (data1.status >= 0) {


            var userImage = self.getCDNUrl(data1.data.ProfilePictureURL);
            var userInitials = common.getInitials(data1.data.Name);
            var userFirstName = data1.data.FirstName;

            console.log("userImage", userImage);
            console.log("userInitials", userInitials);
            console.log("userFirstName", userFirstName);


            //document.getElementById("overlay-test").style.display = "flex";

            self.showGoogleOneTapOption = false;
            firebase
              .auth()
              .signInWithCustomToken(data1.customToken)
              .then(function (res) {
                console.log(`custom token Success Execution time:`, new Date());
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var checkGoogleTapToSignin = document.getElementById(
                      "credential_picker_container"
                    );
                    if (checkGoogleTapToSignin) {
                      document.getElementById(
                        "credential_picker_container"
                      ).style.display = "none";
                    }
                    var decoded = jwt_decode(idToken);
                    debugger;
                    console.log(
                      `get token Success Execution time:`,
                      new Date()
                    );
                    console.log("data>>>>>>>",data1);
                    if (data1.userEvents.result.length > 0) {
                      document.cookie =
                        "Set-Cookie:name=" +
                        data1.userEvents.result[0].client.ClientName +
                        ";" +
                        "domain=e2m.live";
                    }
                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    that.$store.commit("addToken", idToken);
                    that.$store.commit("setCurrentLoggedInTime", decoded.exp);

                    if (!self.visitorLogin && !self.autoLogin) {
                      that.$store.commit(
                        "setIsAccessCodeLogin",
                        self.eventId ? true : false
                      );
                    }
                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";
                    if (
                      $("#chkStaySigned") &&
                      $("#chkStaySigned").length > 0 &&
                      $("#chkStaySigned")[0].checked == true
                    ) {
                      document.cookie = "staysigned=true";
                      store.state.staySignedIn = true;
                      //store.state.userRole = data.data.UserRoles;

                      //store.state.userRole = data.data.UserRoles.concat([
                      //  { RoleID: 99, RoleName: "Visitor" },
                      //]);
                      //store.state.userRole = [
                      //  { RoleID: 99, RoleName: "Visitor" },
                      //];
                      store.state.userId = data1.data.UserId;
                      document.cookie =
                        "userrole=" + JSON.stringify(data1.data.UserRoles) + ";";
                      document.cookie = "userid=" + data1.data.UserId + ";";
                    }
                    ////////// After token and cookies set send to event////////////////////
                    store.commit("setLoginType", "Login");
                    self.recaptchaToken = null;
                    // that.$store.commit(
                    //   "setClientEventBranding",
                    //   data.userEvents.result[0].client.isCustomEventBranding
                    // );
                    var eventCount = 0;
                    console.log("data>222>>>>>>",data1);
                    if (data1.userEvents.result.length > 0) {
                      eventCount = data1.userEvents.result.reduce(
                        (total, user) => {
                          return total + user.events.length;
                        },
                        0
                      );
                    }
                    store.commit("addEventCount", eventCount);
                    $("#btnLogin").prop("disabled", true);
                    var userData = data1.data;
                    var userRoles = userData.UserRoles;
                    var roles = [];
                    var isClientAdmin = false;
                    var isEventAdmin = false;
                    var isUserVisitor = false;
                    if (userRoles != undefined) {
                      userRoles.forEach(function (role) {
                        if (role.RoleID == 2) {
                          isClientAdmin = true;
                        } else if (role.RoleID == 3) {
                          isEventAdmin = true;
                        } else if (role.RoleID == 99) {
                          isUserVisitor = true;
                        }
                        roles.push(role.RoleID);
                      });
                    }
                    if (userData.Email == "visitor@e2m.live") {
                      isUserVisitor = true;
                    }
                    if (isUserVisitor) {
                      if (!roles.includes(99)) {
                        roles.push(99);
                        userRoles.push({ RoleID: 99, RoleName: "Visitor" });
                      }
                    }
                    store.state.userRole = userRoles;
                    console.log("data>>3>>>>>",data1);

                    var result = data1.userEvents.result;
                    var events = [];
                    var i;
                    var j;

                    for (i = 0; i < result.length; ++i) {
                      for (j = 0; j < result[i].events.length; j++) {
                        if (!isClientAdmin && !isEventAdmin) {
                          if (result[i].events[j].IsPublished == true) {
                            events.push(result[i].events[j]);
                          }
                        } else {
                          events.push(result[i].events[j]);
                        }
                      }
                    }
                    if (self.visitorLogin || self.autoLogin) {
                      events = events.filter(function (item) {
                        return item.EventId == self.eventId;
                      });
                    }
                    store.commit("setMappedEvent", events);
                    store.commit("addEventCount", events.length);
                    store.commit("addAttendeeID", userData.UserId);
                    store.commit("setAdminRoles", data1.data.AdminRoles);
                    var UserType = "Attendee";
                    if (userData.RegistrationTypes != undefined)
                      for (var reg in userData.RegistrationTypes) {
                        if (
                          userData.RegistrationTypes[reg].RegistrationType ==
                          "Speaker"
                        ) {
                          UserType = "Speaker";
                        }
                      }

                    store.commit("addUser", {
                      id: userData.UserId,
                      Email: userData.Email,
                      name: userData.Name,
                      fname: userData.FirstName,
                      lname: userData.LastName,
                      profilepic: userData.ProfilePictureURL,
                      company: userData.Company,
                      title: userData.Designation,
                      phone: userData.Phone,
                      roles: roles,
                      userType: UserType,
                    });
                    console.log(
                      `before push Success Execution time:`,
                      new Date()
                    );

                    debugger;

                    if (eventCount == 0 && self.EnableSelfService) {
                      if (self.$route.fullPath == "/#cevent") {
                        bus.$emit("toggleLoader", false);
                        router.push("/eventoverview/#cevent");
                      } else {
                        bus.$emit("toggleLoader", false);
                        router.push({ name: "AdminOverview" });
                      }
                    } else {
                      if (
                        store.state.DefaultLoginLandingPage == "/clientLobby"
                      ) {
                        // if (self.isClientAdmin() == true) {
                        //   router.push("/dashboard");
                        // } else {
                        //   router.push("/mainlobby");
                        // }
                        bus.$emit("toggleLoader", false);
                         var data = {
                          showUserWelcomeLoader: false,
                        };
                        

                        bus.$emit("setUserWelcomeLoader", data);
                        router.push("/mainlobby");
                      } else {
                        if (events.length > 1) {
                          if (self.hasRedirectUrl() && self.eventId) {
                            self.goToRedirectUrl();
                          } else {
                            if (
                              self.EnableSelfService &&
                              self.hasEventAdminRole()
                            ) {
                              if (self.$route.fullPath == "/#cevent") {
                                bus.$emit("toggleLoader", false);
                                router.push("/eventoverview/#cevent");
                              } else {
                                bus.$emit("toggleLoader", false);
                                //router.push({ name: "AdminOverview" });
                                router.push({ name: "BasicInfo" });
                              }
                            } else {
                              bus.$emit("toggleLoader", false);
                              router.push({ name: "EventList" });
                            }
                          }
                          if (self.allowreCAPTCHA) self.resetCaptcha();
                        } else if (events.length == 0) {
                          document.getElementById("dvOtherMsg").innerText =
                            self.$t("login.eventnotpublished");
                          $("#Othermsg-modal").modal("show");
                          $("#btnLogin").val(self.$t("login.title"));
                          self.loginText = self.$t("login.title");
                          that.mainLoginButtonLoader = false;

                          if (self.allowreCAPTCHA) self.resetCaptcha();
                        } else {
                          self.getEventDetails(data);

                          if (self.allowreCAPTCHA) self.resetCaptcha();
                        }
                      }
                    }

                    //return true;

                    //}
                  })
                  .catch((err) => {
                    console.log("err=====", err);
                    that.mainLoginButtonLoader = false;
                    self.reLoginMessageFlg = true;
                    if (self.allowreCAPTCHA) self.resetCaptcha();
                  });
              })
              .catch(function (e) {
                console.log(e);
                that.mainLoginButtonLoader = false;
                self.reLoginMessageFlg = true;
                self.loginText = self.$t("login.title");
                self.recaptchaToken = null;
                if (self.allowreCAPTCHA) self.resetCaptcha();
              });
          } else {
            $("#btnLogin").val(self.$t("login.title"));

            self.loginText = self.$t("login.title");
            self.showSnackbar(
              self.eventId
                ? self
                  .$t("login.loginfailedvaildemailandpwd")
                  .replace("password", "event access code")
                : self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );
            that.mainLoginButtonLoader = false;
            self.loginText = self.$t("login.title");
            if (self.allowreCAPTCHA) that.resetCaptcha();
            return false;
          }
        },
        error: function (xhr, status, error) {
          if (self.allowreCAPTCHA) self.resetCaptcha();
          that.mainLoginButtonLoader = false;
          self.reLoginMessageFlg = true;
          debugger;
          self.loginText = self.$t("login.title");
          document.getElementById("dvOtherMsg").value =
            self.$t("login.errorinauth") + error;
          $("#Othermsg-modal").modal("show");
        },
      });
    },
    hasRedirectUrl: function () {
      var result = false;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.urlReq && !obj.urlReq.includes("undefined")) {
        var pathArray = obj.urlReq.split("/");
        if (pathArray.length > 1) {
          result = true;
        }
      }
      return result;
    },
  }
}